import Vue from 'vue';

Vue.component('basket-size-index', () =>
    import(/* webpackChunkName: 'basket-size-index' */ './basket-size-index.vue'),
);
